/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-access-state-in-setstate */

import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { connect } from 'react-redux';
import Checkbox from 'react-three-state-checkbox/lib/Checkbox';
import { Dispatch } from 'redux';
import { change } from 'redux-form';
import { EventType, isUnknownParticipantName, ParticipantState, ParticipantViewModel } from 'stageclip-common';

import { createAllEventParticipantsRequestedAction } from '../../../actions/participantActions';
import { DataRequestActionTypes } from '../../../constants/actionTypes';
import { FormId } from '../../../constants/formId';
import { ClippingPlatformState } from '../../../store/clippingPlatformState';
import { getAllWithIds, getItem } from '../../../store/selectors';
import {
  baseMapDispatchToProps,
  baseMapStateToProps,
  ComponentBase,
  BaseDispatchProps,
  BaseStateProps,
} from '../../componentBase';
import { AppCheckboxField } from '../../form/appCheckboxField';
import FormModal from '../../modal/formModal';

import { ParticipantsState } from './participantsState';
import styles from './sendParticipantsToRemotionGeneratorForm.module.scss';
import { NormalizedEvent } from 'models/normalized/normalizedEvent';

interface SendParticipantsToRemotionGeneratorFormOwnProps {
  eventId: string;
  event: NormalizedEvent;
}

interface SendParticipantsToRemotionGeneratorFormStateProps extends BaseStateProps {
  participants: ParticipantViewModel[];
  formValues: any;
  eventType: EventType;
}

interface SendParticipantsToRemotionGeneratorFormDispatchProps extends BaseDispatchProps {
  loadEventParticipants: (c: SendParticipantsToRemotionGeneratorForm) => void;
  changeFieldValue: (field: string, value: any) => void;
}

interface SendParticipantsToRemotionGeneratorFormState {
  filteredParticipants: ParticipantViewModel[];
  sendParticipantToGenerator: boolean;
}

enum CheckboxState {
  AllChecked,
  AllUnchecked,
  PartiallyChecked,
}

class SendParticipantsToRemotionGeneratorForm extends ComponentBase<
  SendParticipantsToRemotionGeneratorFormOwnProps,
  SendParticipantsToRemotionGeneratorFormStateProps,
  SendParticipantsToRemotionGeneratorFormDispatchProps,
  SendParticipantsToRemotionGeneratorFormState
> {
  private checkBoxesState: any;

  private participants: any;

  constructor(props: any) {
    super(props);
    this.checkBoxesState = {
      error: CheckboxState.AllUnchecked,
      processed: CheckboxState.AllUnchecked,
      readyToGenerateClip: CheckboxState.AllChecked,
      sentToGenerator: CheckboxState.AllUnchecked,
    };
    this.state = {
      filteredParticipants: undefined,
      sendParticipantToGenerator: true,
    };
  }

  protected dataLoaded(props: any) {
    return props.participants;
  }

  protected loggedInRender() {
    this.participants = {
      error: this.getParticipantsWithState(ParticipantState.Error),
      processed: this.getParticipantsWithState(ParticipantState.Processed),
      readyToGenerateClip: this.getParticipantsWithState(ParticipantState.ReadyToGenerateClip),
      sentToGenerator: this.getParticipantsWithState(ParticipantState.SentToGenerator),
    };

    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      ...this.state,
      filteredParticipants: this.props.participants ? this.props.participants : undefined,
    });

    const initialValues = {};

    this.participants.readyToGenerateClip.forEach((p: any) => {
      initialValues[p.id.toString()] = true;
    });

    const preprocessDataOnSubmitForLiveAndHybridEvent = this.preprocessDataOnSubmitForLiveAndHybridEvent.bind(this);

    const onModalClosed = this.onModalClosed.bind(this);

    return (
      <>
        {(this.props.eventType === EventType.LiveEvent ||
          this.props.eventType === EventType.HybridClipsOnlyEvent ||
          this.props.eventType === EventType.HybridFullCeremonyEvent) && (
          <FormModal
            formId={FormId.SendLiveParticipantsToRRE}
            formTitle="Send participants to RRE"
            buttonIcon={faPaperPlane}
            invertedButtonColours
            initialValues={initialValues}
            submitActionType={DataRequestActionTypes.SendLiveParticipantsToRemotionGeneratorRequested}
            reduxData={{ eventId: this.props.eventId, eventType: this.props.eventType }}
            preprocessDataOnSubmit={preprocessDataOnSubmitForLiveAndHybridEvent}
            onClosed={onModalClosed}
            onSuccessCallback={() => this.props.loadEventParticipants(this)}
          >
            <div className={styles.warning}>
              {// eslint-disable-next-line no-nested-ternary
              this.props.event.eventConfiguration
                ? this.props.event.eventConfiguration.isLiveTemplateFinalize
                  ? ''
                  : 'Clip template has not been finalized.'
                : 'Clip template not selected'}
            </div>
            <br />
            {/* <AppCheckboxField
              name="showParticipants"
              label="Send to all Participants"
              value={!this.state.sendParticipantToGenerator}
              onChange={() => this.setState({ sendParticipantToGenerator: !this.state.sendParticipantToGenerator })}
            /> */}
            {/* {this.state.sendParticipantToGenerator && (
              <AppSelectField
                name="participantId"
                options={this.getParticipants()}
                label="Select Participants"
                onChangeCallback={this.selectParticipant}
                validate={[required]}
              />
            )} */}
            {this.state.filteredParticipants && (
              <>
                <div>Select/Deselect all participants with status:</div>
                <div className={styles.checkboxes}>
                  {this.renderMainCheckbox('Ready to Generate Clip', 'readyToGenerateClip')}
                  {this.renderMainCheckbox('Processed', 'processed')}
                  {this.renderMainCheckbox('Error', 'error')}
                  {this.renderMainCheckbox('Sent to generator', 'sentToGenerator')}
                </div>
                {this.displayParticipants('readyToGenerateClip')}
                {this.displayParticipants('error')}
                {this.displayParticipants('processed')}
                {this.displayParticipants('sentToGenerator')}
              </>
            )}
          </FormModal>
        )}
      </>
    );
  }

  private renderMainCheckbox(label: string, group: string) {
    const onChange = this.onGroupCheckboxChange(group).bind(this);

    return (
      <div className={styles.mainCheckbox}>
        {label}&nbsp;
        <Checkbox
          checked={this.checkBoxesState[group] === CheckboxState.AllChecked}
          indeterminate={this.checkBoxesState[group] === CheckboxState.PartiallyChecked}
          onChange={onChange}
        />
      </div>
    );
  }

  private onModalClosed = () => {
    this.setState({
      filteredParticipants: undefined,
    });
    this.checkBoxesState = {
      error: CheckboxState.AllUnchecked,
      processed: CheckboxState.AllUnchecked,
      readyToGenerateClip: CheckboxState.AllChecked,
      sentToGenerator: CheckboxState.AllUnchecked,
    };
  };

  private preprocessDataOnSubmitForLiveAndHybridEvent = (formData: any) => {
    return {
      eventId: this.props.eventId,
      // participantId: this.state.filteredParticipantId,
      participantIds: Object.keys(formData).reduce((f, key) => {
        if (formData[key]) {
          f.push(key);
        }

        return f;
      }, []),
    };
  };

  private onGroupCheckboxChange = (group: string) => async () => {
    this.checkBoxesState[group] =
      this.checkBoxesState[group] === CheckboxState.AllChecked ? CheckboxState.AllUnchecked : CheckboxState.AllChecked;

    if (this.checkBoxesState[group] === CheckboxState.AllChecked) {
      await this.participants[group].forEach(async (p: any) => {
        await this.props.changeFieldValue(p.id, true);
      });
    } else {
      await this.participants[group].forEach(async (p: any) => {
        await this.props.changeFieldValue(p.id, false);
      });
    }
  };

  private onParticipantCheckboxChange = (group: string) => async (input: any) => {
    if (input.target.checked) {
      if (this.checkBoxesState[group] === CheckboxState.PartiallyChecked) {
        if (
          !this.participants[group].some(
            (p: any) => p.id !== input.target.name && this.props.formValues && !this.props.formValues[p.id],
          )
        ) {
          this.checkBoxesState[group] = CheckboxState.AllChecked;
        }
      } else {
        this.checkBoxesState[group] = CheckboxState.PartiallyChecked;
      }
    } else if (this.checkBoxesState[group] === CheckboxState.PartiallyChecked) {
      if (
        !this.participants[group].some(
          (p: any) => p.id !== input.target.name && this.props.formValues && this.props.formValues[p.id],
        )
      ) {
        this.checkBoxesState[group] = CheckboxState.AllUnchecked;
      }
    } else {
      this.checkBoxesState[group] = CheckboxState.PartiallyChecked;
    }
  };

  private displayParticipants(group: string) {
    const onChange = this.onParticipantCheckboxChange(group).bind(this);

    return this.participants[group].map((p: any) => (
      <AppCheckboxField
        name={p.id}
        label={this.participantLabel(p)}
        key={p.id}
        inputClassName={styles.input}
        labelClassName={styles.label}
        onChange={onChange}
      />
    ));
  }

  private participantLabel(participant: ParticipantViewModel) {
    return (
      <div className={styles.participantLabel}>
        <div className={styles.participantName}>{participant.fullName}</div>
        <ParticipantsState state={participant.state} />
      </div>
    );
  }

  // private selectParticipant = (value: any) => {
  //   this.setState({
  //     // eslint-disable-next-line react/no-access-state-in-setstate
  //     ...this.state,
  //     filteredParticipants: value.value ? this.props.participants.filter(p => p.fullName) : [],
  //     filteredParticipantId: value.value,
  //   });
  // };

  private getParticipantsWithState(state: ParticipantState) {
    return this.state.filteredParticipants ? this.state.filteredParticipants.filter(p => p.state === state) : [];
  }
}

function mapStateToProps(
  state: ClippingPlatformState,
  ownProps: SendParticipantsToRemotionGeneratorFormOwnProps,
): SendParticipantsToRemotionGeneratorFormStateProps {
  const event = getItem(state.entities.events, ownProps.eventId);
  const formData = state.form[FormId.SendLiveParticipantsToRRE];
  const allParticipants = getAllWithIds(state.entities.participants, event.participants);

  return {
    ...baseMapStateToProps(state),
    eventType: event.type,
    formValues: formData ? formData.values : undefined,
    participants: allParticipants ? allParticipants.filter(p => !isUnknownParticipantName(p.fullName)) : null,
  };
}

function mapDispatchToProps(
  dispatch: Dispatch,
  ownProps: SendParticipantsToRemotionGeneratorFormOwnProps,
): SendParticipantsToRemotionGeneratorFormDispatchProps {
  return {
    ...baseMapDispatchToProps(dispatch),
    changeFieldValue: (field, value) => dispatch(change(FormId.SendLiveParticipantsToRRE, field, value)),
    loadEventParticipants: (c: SendParticipantsToRemotionGeneratorForm) =>
      dispatch(createAllEventParticipantsRequestedAction(ownProps.eventId, c, dispatch)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SendParticipantsToRemotionGeneratorForm);
